export default __webpack_public_path__ + "static/ex-1-lg_2-f8e5b082ce060f0848e4ecf8f4d1723e.png";